<script>
import { Message, Modal, Button, Table } from 'ant-design-vue'
import api from '@/command/api'
import TableView from '@/components/TableVIew'
import FormHeader from '@/components/FormHeader'
import { productTypeSpecialtyList } from '@/utils/textFile'
import { getAction } from '@/command/netTool'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '选择商品',
    },
    defaultValue: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: '/commodity/farmNativeProduct/page',
    },
  },
  data() {
    return {
      visible: false,
      rows: [],
      selectedRows: [],
      list: [],
      searchData: {},
      listParams: {
        total: 10,
        current: 1,
        size: 10,
      },
    }
  },
  watch: {
    show(val) {
      if (this.visible === val) return
      this.visible = val
    },
  },
  mounted() {
    this.getList()
    this.show = this.modelValue
  },
  methods: {
    getList(current = 1, size = 10) {
      let params = { ...this.searchData, upDown: '0', current, size }
      getAction(`${this.url}`, params).then((e) => {
        this.listParams = { total: e.data.total, size: e.data.size, current: e.data.current }
        this.list = e.data.records
      })
    },
    getHeader() {
      return [
        {
          name: '特产名称',
          key: 'nativeProductName',
          type: 'input',
        },
        {
          name: '店铺名称',
          key: 'linkShop',
          type: 'input',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'nativeProductName',
          title: '特产名称',
          align: 'left',
          customRender: (text, records) => {
            return (
              <div class="product-order-item-copy">
                {records.bannerUrl ? <img src={records.bannerUrl.split(',')[0]} /> : ''}
                <div>{text}</div>
              </div>
            )
          },
          sorter: (a, b) => a.nativeProductName.length - b.nativeProductName.length,
        },
        {
          dataIndex: 'farmNativeProductStandardsVOS',
          title: '规格',
          getData: (records) => records.farmNativeProductStandardsVOS.slice(0, 3).map((e) => e.standardsName),
          type: 'tagGroup',
          align: 'left',
          onExport: (text, records) => {
            let arr = text.map((e) => {
              return e.standardsName
            })
            return arr.toString()
          },
        },
        {
          dataIndex: 'productType',
          title: '商品类型',
          align: 'left',
          width: 100,
          customRender: function (text, records) {
            return text ? productTypeSpecialtyList.find((e) => text == e.value).name : ''
          },
          onExport: (text) => {
            text ? productTypeSpecialtyList.find((e) => text == e.value).name : ''
          },
     
        },
        {
          dataIndex: 'linkShop',
          title: '店铺名称',
          align: 'left',
        },
        {
          dataIndex: 'salePrice',
          title: '现价',
          align: 'left',
          customRender: function (text, records) {
            return records.salePrice == null ? '' : <div>{'￥' + records.salePrice}</div>
          },
        },
        {
          dataIndex: 'vipPrice',
          title: '会员价',
          align: 'left',
          width: 60,
          customRender: function (text, records) {
            return records.vipPrice == null ? '' : <div>{'￥' + records.vipPrice}</div>
          },
        },
        {
          dataIndex: 'categories',
          title: '分类',
          align: 'left',
        },
      ]
    },
    onSelectRow(ids) {
      this.selectKeys = ids
    },
  },
  render() {
    return (
      <Modal
        title={this.title}
        visible={this.visible}
        onCancel={() => this.$emit('cancel', false)}
        width={'1260px'}
        onOk={() => {
          this.$emit('ok', this.selectedRows)
        }}
      >
        <FormHeader
          data={this.getHeader()}
          onSuccess={(data) => {
            this.searchData = { ...this.searchData, ...data }
            this.getList(1, this.listParams.size)
          }}
          onReset={() => {
            this.searchData = {}
            this.getList()
          }}
        />
        <TableView
          ref={'table'}
          dataSource={this.list}
          pagination={this.listParams}
          onSelectRow={(selectedRowIds, selectedRows) => {
            if (!selectedRows) return
            // selectedRows 只会返回单页选中的数组，所以需要合并已选择的数组和单页选中的数组
            let selectList = selectedRows
            if (selectedRowIds.length !== selectedRows.length) {
              const filList = this.defaultValue.filter((e) => selectedRowIds.includes(e.relationId))
              // 合并后根据 relationId 或 id 去重
              const seenIds = new Set()
              selectList = [...filList, ...selectedRows].filter((item) => {
                const id = item.relationId || item.id
                if (seenIds.has(id)) return false
                seenIds.add(id)
                return true
              })
            }
            this.selectedRows = selectList
          }}
          selectedRowKeys={this.defaultValue.map((e) => e.relationId || e.id)}
          columns={this.getColumns()}
          onChange={(pagination) => {
            this.getList(pagination.current, pagination.pageSize)
          }}
        />
      </Modal>
    )
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-table-body {
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
/deep/ .header-box {
  margin-left: 0 !important;
}
</style>
